import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const { t } = useLanguage();

  const faqs = [
    { question: t.faq?.q1 || 'Comment effectuer un échange ?', answer: t.faq?.a1 || 'Sélectionnez la cryptomonnaie, entrez le montant, choisissez votre méthode de paiement et confirmez.' },
    { question: t.faq?.q2 || 'Combien de temps dure l\'échange ?', answer: t.faq?.a2 || 'La plupart des échanges sont traités en 5 à 15 minutes.' },
    { question: t.faq?.q3 || 'Quels sont vos frais ?', answer: t.faq?.a3 || 'Commission de 7% sur toutes les opérations d\'achat, de vente et d\'envoi.' },
    { question: t.faq?.q4 || 'Quelles méthodes de paiement ?', answer: t.faq?.a4 || 'SEPA, Revolut, Visa, Mastercard, Cashlib, Transcash, Neosurf, PCS.' },
    { question: t.faq?.q5 || 'Mes données sont-elles sécurisées ?', answer: t.faq?.a5 || 'Chiffrement de niveau bancaire pour protéger vos données.' },
    { question: t.faq?.q6 || 'Programme de parrainage ?', answer: t.faq?.a6 || '10% de commission sur les frais de transaction de vos filleuls, à vie !' },
  ];

  return (
    <section className="py-24 px-6 bg-white" data-testid="faq-section">
      <div className="max-w-3xl mx-auto">
        <h2 className="font-extrabold text-4xl md:text-5xl text-gray-900 mb-4 text-center tracking-tight" style={{ fontFamily: 'Manrope' }}>{t.faq?.title || 'Questions fréquentes'}</h2>
        <p className="text-gray-500 text-center mb-12">{t.faq?.subtitle || 'Tout ce que vous devez savoir'}</p>
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div key={index} className={`bg-[#F5F6F7] rounded-3xl overflow-hidden transition-colors ${openIndex === index ? 'bg-gray-100' : ''}`} data-testid={`faq-item-${index}`}>
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-6 text-left" data-testid={`faq-toggle-${index}`}>
                <span className="font-bold text-gray-900 pr-4">{faq.question}</span>
                <div className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${openIndex === index ? 'bg-[#191C1F] text-white' : 'bg-white text-gray-500'}`}>
                  {openIndex === index ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                </div>
              </button>
              {openIndex === index && <div className="px-6 pb-6"><p className="text-gray-500 leading-relaxed">{faq.answer}</p></div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
